export const Colors = {
  black: "#000000",
  white: "#FFFFFF",
  destructGreen: "#B2EC85",
  destructRed: "#F44A4A",
  darkGrey: "#333333",
  lightGrey: "#4F4F4F",
  backgroundEggshell: "#F2F2F2",
  blueish: "#061529",
};